import { api } from "../api";

export interface NotificationReference {
  type: string;
  id: string;
}

export interface NotificationProps {
  id: string;
  topic: string;
  title: string;
  body: string;
  recipientType: string;
  recipientId: string;
  reference?: NotificationReference | null;
  read: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface NotificationsResponse {
  data: NotificationProps[];
  total: number;
  page: number;
  lastPage: number;
}

export interface UnreadCountResponse {
  unread: number;
}

export async function buscarNotificacoes(page = 1, limit = 20): Promise<NotificationsResponse> {
  const response = await api.get<NotificationsResponse>("/notifications", {
    params: {
      page,
      limit,
    },
  });
  return response.data;
}

export async function buscarQuantidadeNaoLidas(): Promise<number> {
  const response = await api.get<UnreadCountResponse>("/notifications/unread-count");
  return response.data.unread;
}

export async function marcarNotificacaoComoLida(id: string): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}

export async function marcarTodasNotificacoesComoLidas(): Promise<void> {
  await api.patch("/notifications/read-all");
}